import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'

export const planPayments = async (data: object) => {
  return axios.post(endpoints.plansPayment, data)
}

export const usePlanPayments = () => {
  const queryClient = useQueryClient()
  return useMutation(planPayments, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.paymentStripe])
      queryClient.invalidateQueries([ApiKey.policies, ApiKey.list])
    },
  })
}
